// frontend-react/src/services/probablePitchersApi.js
// API service for probable pitchers

import apiService from './apiService';

/**
 * Fetch probable starting pitchers for a date range
 * 
 * @param {string} leagueId - League UUID
 * @param {string} teamId - Team UUID
 * @param {string} startDate - Start date (YYYY-MM-DD)
 * @param {number} days - Number of days to fetch (default 5)
 * @returns {Promise} API response with games and teams
 */
export const fetchProbablePitchers = async (leagueId, teamId, startDate, days = 5) => {
  try {
    const response = await apiService.get(
      `/api/leagues/${leagueId}/teams/${teamId}/probable-pitchers`,
      {
        params: {
          start_date: startDate,
          days: days
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching probable pitchers:', error);
    
    // Return error in consistent format
    return {
      success: false,
      detail: error.response?.data?.detail || error.message || 'Failed to fetch probable pitchers',
      games: [],
      teams: []
    };
  }
};

export default {
  fetchProbablePitchers
};
